import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import MyBundlingPackage from './MyBundlingPackage';
import BrowseInventory from './BrowseInventory';
import PlatformIntegration from './PlatformIntegration';
import TransactionMonitor from './TransactionMonitor';
import ProductManagerOverview from './product-manager/ProductManagerOverview';
import ProductManagerTemplates from './product-manager/ProductManagerTemplates';
import DraftsReadiness from './product-manager/DraftsReadiness';

const resolvePage = (pathname) => {
  const segment = pathname.split('/').filter(Boolean).pop();
  return segment === 'package-manager' ? 'overview' : segment;
};

const PackageManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const page = resolvePage(location.pathname);

  const handleUseTemplate = (template) => {
    localStorage.setItem(
      'packageTemplateDraft',
      JSON.stringify({
        ...template,
      })
    );
    navigate('/admin/package-manager/my-packages?create=template');
  };

  if (page === 'overview') return <ProductManagerOverview />;
  if (page === 'my-packages') return <MyBundlingPackage />;
  if (page === 'product-catalog') return <BrowseInventory />;
  if (page === 'templates') return <ProductManagerTemplates onUseTemplate={handleUseTemplate} />;
  if (page === 'drafts-readiness') return <DraftsReadiness />;
  if (page === 'integrations') return <PlatformIntegration />;
  if (page === 'channel-transactions') return <TransactionMonitor />;
  return <Navigate to="/admin/package-manager/overview" replace />;
};

export default PackageManager;
